module.exports = __webpack_public_path__ + "img/lw-logo-lightwork.6f278d64.png";